import React from 'react';
import genderId from '../../../../../hooks/genderId';
import NotInformation from '../../../../../components/NotInformation';
import { CustomCardGrid } from '../../../../../components/CustomCardGrid';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import RowCardText from '../../../../../components/RowCardText';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { permissionObj } from "../../../../../Helpers/permission";
import {status} from "../../../../../enums/statusEnum";
import { statusBorderColor, statusColor, statusFontColor } from "../../../../../enums/statusColorEnum";
import { getViewTypeByName } from "../../../../../enums/ViewType";
import { ArrowRightIcon, EmailSubsectionChip, PhoneSubsectionChip } from '../../../../../components/buttons/IconButtons';
import AllEmployeeCardsApp from '../Functionality/AllEmployeeCardsApp';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import DisplayView from '../../../../../components/DisplayView';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {EMPTY_VALUES, getFullName} from '../../../../../Apis/functions';
import IconPersonDefault from '../../../../../assets/ImagesDefaults/ic-person-v2.svg';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param props
 */
const AllEmployeeCards = (props) => {

    const {
        contractorId,
        supplierId,
        isAllChecked,
        setIsAllChecked,
        setSearch,
        setSimpleSearch,
        searchElement,
        setSearchElement,
        selectedList,
        setSelectedList,
        view,
        option,
        setBodyForExport,
        setCriteria,
        goCreate,
        modified,
        setModified,
        finalArray,
        handleView,
        showActionsContractorSupplier
    } = props;

    const {
        searchResults, setSearchResults,
        searchId,
        elementRef,
        handleOnClick,
        DEV,
        permission,
        t,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
    } = AllEmployeeCardsApp({
        contractorId,
        supplierId,
        setIsAllChecked,
        setSimpleSearch,
        searchElement,
        selectedList,
        setSelectedList,
        modified,
        setModified,
        finalArray,
        view,
        setCriteria,
        option,
        setBodyForExport
    });

    return (
        <>
            <div className="d-flex">
                <DisplayView view={view} setView={handleView} left={0} />
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>
            {searchResults?.content?.length > 0 ?
                <>
                    <div>
                   {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DELETE)) && (
                        <CustomCheckbox
                            id={"cb_aec_all_checked"}
                            trans={'de_/_select_all'}
                            name={"isAllChecked"}
                            checked={isAllChecked}
                            onChange={handleDeleteAll}
                        />)}
                    </div>
                    <div className='panelTables' ref={elementRef}>
                        <div className='row'>
                            {searchResults?.content?.map((item, index) => {
                                const fullName = item?.fullName || getFullName(item?.name, item?.lastName, item?.secondLastName);
                                const canUpdate = DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE);
                                // Without the update permission, read-only users go to the details view
                                const showDetails = !contractorId && !supplierId && !canUpdate
                                    && permission?.includes(permissionObj?.WEB_EMPLOYEE_READ);
                                const showButton = ((contractorId || supplierId) && (showActionsContractorSupplier || item?.periodId))
                                                    || canUpdate || showDetails;
                                const buttonText = showDetails ? 'details'
                                    : (contractorId || supplierId) && item?.periodId ? 'documentation': 'update';

                                return (
                                    <CustomCardGrid
                                        classNamePanelGrid='col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 px-1 mb-3'
                                        itemId={item?.id}
                                        checked={selectedList?.includes(item?.id)}
                                        onCheckboxChange={handleCheckboxChange}
                                        disabled={false}
                                        isCheckboxShow={DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DELETE)}
                                        statusColor={statusColor[item?.statusId]}
                                        statusName={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                                        fontColor={statusFontColor[item?.statusId]}
                                        borderColor={statusBorderColor[item?.statusId]}
                                        chipVariant="large"

                                        srcImage={item?.selfie != null ? `data:image/png;base64,${item?.selfie}` : IconPersonDefault}
                                        backgroundImage={item?.selfie != null ? `data:image/png;base64,${item?.selfie}` : ''}
                                        btnActions={ (showButton) ?
                                                <ButtonActionsCard
                                                    id={`btn_aec_actions_card_${index + 1}`}
                                                    name={buttonText}
                                                    Icon={ArrowRightIcon}
                                                    onClick={() => {
                                                        handleOnClick(contractorId, supplierId, item)
                                                    }}
                                                />
                                                : ''
                                        }
                                    >
                                        <div className="px-2">
                                            { (contractorId || supplierId) ?
                                                <>
                                                    <div className="justify-content-center align-items-center">
                                                        <CustomTooltip
                                                            text={fullName}
                                                            classes={"fs-18px font-color-general-950 ibl-font-w-500 text-center text-ellipsis-2-rows"}
                                                            showIfTruncated={true}
                                                            placement={"top"}
                                                        />
                                                    </div>

                                                    <div className={"border-bottom-shades-300-2px my-3"} />

                                                    <div className="row d-flex justify-content-center align-items-center">
                                                        <div className="col-6 pl-0">
                                                            <div className="d-flex justify-content-start align-items-center">
                                                                <div className="pr-2 align-items-center"><EmailSubsectionChip className='icon-color-general-950' width={20} height={20} /></div>
                                                                <div className={"flex-grow-1 minw-0"}>
                                                                    <CustomTooltip
                                                                        text={t("email")}
                                                                        classes={`fs-12px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row pt-1`}
                                                                        showIfTruncated={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 pr-0">
                                                            <CustomTooltip
                                                                text={item.email}
                                                                classes={"fs-14px font-color-shades-950 ibl-font-w-300 text-ellipsis-1-row text-end"}
                                                                showIfTruncated={true}
                                                                placement={"top"}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row d-flex justify-content-center align-items-center mt-3">
                                                        <div className="col-6 pl-0">
                                                            <div className="d-flex justify-content-start align-items-center">
                                                                <div className="pr-2 align-items-center"><PhoneSubsectionChip className='icon-color-general-950' width={20} height={20} /></div>
                                                                <div className={"flex-grow-1 minw-0"}>
                                                                    <CustomTooltip
                                                                        text={t("phone_number")}
                                                                        classes={`fs-12px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row`}
                                                                        showIfTruncated={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 pr-0">
                                                            <CustomTooltip
                                                                text={item.phoneNumber}
                                                                classes={"fs-14px font-color-shades-950 ibl-font-w-300 text-ellipsis-1-row text-end"}
                                                                showIfTruncated={true}
                                                                placement={"top"}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <RowCardText title={t('name')} value={fullName} />
                                                    <RowCardText title={t('work_station')} value={item?.workStation || EMPTY_VALUES.DEFAULT} />
                                                    <RowCardText title={t('gender')} value={genderId(item?.genderId) || EMPTY_VALUES.DEFAULT} />
                                                    <RowCardText title={t('email')} value={item?.email || EMPTY_VALUES.DEFAULT} />
                                                    <RowCardText title={t('phone_number')} value={item?.phoneNumber || EMPTY_VALUES.DEFAULT} />
                                                    <RowCardText title={t('employee_id')} value={item?.role || EMPTY_VALUES.DEFAULT} />
                                                    <RowCardText title={t('ceco')} value={item?.cecoCode || EMPTY_VALUES.DEFAULT} tooltip={item?.cecoCode}/>
                                                    <RowCardText title={t('privilege')} value={item?.employeeId || EMPTY_VALUES.DEFAULT} />
                                                    <RowCardText title={t('department')} value={item?.department || EMPTY_VALUES.DEFAULT} />
                                                </>
                                            }
                                        </div>
                                    </CustomCardGrid>
                                );
                            })}
                        </div>
                    </div>

                    {pagination()}
                </>
                :
                <NotInformation card={true}>
                    <>
                        <div className={"warning-text"}>
                            <p>{t("you_haven_not_created_any_employee")}</p>
                        </div>
                        {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_CREATE)) &&
                            <CustomButtonLink
                                splitName={false}
                                id={'btn_aec_create'}
                                card={true}
                                onClick={() => {
                                    goCreate();
                                }}
                                name={'create_new_employee'}
                            />
                        }
                    </>
                </NotInformation>
            }
        </>
    );
};

export default AllEmployeeCards;
